<div class="fixed-table-header-container" *ngIf="showOpeningSizes">
  <table cellspacing="0">
    <thead>
    <tr>
      <th>Outer</th>
      <th>Artwork</th>
      <th>Opening</th>
    </tr>
    </thead>
  </table>
  <div class="fixed-table-header-container-inner">
    <table cellspacing="0">
      <tbody>
      @for (size of availableSizes; track size) {
        <tr (click)="selectSize(size)" [ngClass]="{selected: selectedSize == size}">
          <td>{{size.outer | size | inches }}</td>
          <td>{{size.artwork | size | inches }}</td>
          <td>{{ size.opening | size | inches }}</td>
        </tr>
      }
    </table>
  </div>
</div>
<mat-form-field *ngIf="!showOpeningSizes">
  <mat-label>Standard Sizes</mat-label>
  <mat-select (selectionChange)="onStandardSizeDropDownChange($event)">
    @for (size of availableSizes; track size) {
    <mat-option [value]="size">
      {{size.outer | size | inches }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>

